<template>
  <div class="course-item-list">
    <div
      class="item"
      v-for="(item, index) in list"
      :key="index"
      @click="$router.push(`/training-detail/${item.uuid}`)"
    >
      <div class="content">
        <div
          class="cover-img"
          :style="{ backgroundImage: `url(${item.trainingCover})` }"
        ></div>
        <div class="bot-wrapper">
          <div class="description">
            {{ item.trainingName }}
          </div>
          <div class="price">
            <div class="num">￥{{ item.price }}</div>
            <div class="register">{{ item.userCount || 0 }}人已报名</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.course-item-list {
  padding: 0.3rem 0 0.5rem;
  display: flex;
  flex-wrap: wrap;
  margin-left: -0.45rem;
  .item {
    width: 25%;
    padding-left: 0.45rem;
    box-sizing: border-box;
    cursor: pointer;
    margin-bottom: 0.45rem;
    .content {
      background: #f4f4f4;
      height: 100%;
      display: flex;
      flex-direction: column;
      .bot-wrapper {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
    .cover-img {
      height: 1.89rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background-size: cover;
    }
    .description {
      padding: 0.16rem 0.11rem 0 0.16rem;
      font-size: 0.18rem;
      line-height: 0.22rem;
      font-weight: bold;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .price {
      margin-top: 0.16rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0.19rem 0.2rem 0.16rem;
      .num {
        font-size: 0.25rem;
        font-weight: bold;
        color: #ff7d00;
      }
      .register {
        font-weight: 500;
        font-size: 0.16rem;
      }
    }
  }
}
</style>